import React from 'react';

// En-tête de page compact sur mobile (1 ligne), complet sur desktop
export const PageHeader = ({ icon: Icon, title, subtitle, gradient = 'from-blue-600 to-indigo-600', testId = 'page-header', actions = null }) => (
  <div data-testid={testId} className="flex items-center gap-2.5 sm:gap-3 min-w-0">
    <div className={`w-9 h-9 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-gradient-to-br ${gradient} flex items-center justify-center shrink-0 shadow-lg`}>
      <Icon className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
    </div>
    <div className="min-w-0 flex-1">
      <h1 className="text-lg sm:text-2xl lg:text-3xl font-bold text-white leading-tight truncate">{title}</h1>
      {subtitle && <p className="hidden sm:block text-sm text-slate-400 truncate">{subtitle}</p>}
    </div>
    {actions}
  </div>
);
